import merge from 'deepmerge';
import { EnvService } from './env.service';

export const EnvServiceFactory = () => {
    const browserWindow = window || {};
    const browserWindowEnv = browserWindow['__env'] || {};
    const env = new EnvService();
    return merge(env, browserWindowEnv);
};

export const EnvServiceProvider = {
    provide: EnvService,
    useFactory: EnvServiceFactory,
    deps: []
};
